@if (this.bewegung(); as bewegung) {
  <div [formGroup]="form">
    <div class="flex flex-col w-full mb-3">
      <div class="font-bold text-sm text-primary-400 mb-1">
        {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.TITEL_MHD' | translate}}
      </div>
      <soft-date-input
        [readonly]="mhdReadonly()"
        formControlName="mhd"
        changeTrigger="blur">
      </soft-date-input>
      @if (!form.controls['mhd'].valid) {
        <div
          class="text-red-800 font-semibold">
          {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.LABEL_GUELTIGES_MHD_ANGEBEN' | translate}}
        </div>
      }
    </div>
    <div class="flex flex-col w-full mb-3">
      <div class="font-bold text-sm text-primary-400 mb-1">
        {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.TITEL_CHARGE' | translate}}
      </div>
      <soft-input
        placeholder="Charge"
        [readonly]="chargeReadonly()"
        formControlName="charge">
      </soft-input>
      @if (!form.controls['charge'].valid || (!isNeuePalette() && !form.controls['charge'].valid)) {
        <div
          class="text-red-800 font-semibold">
          {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.LABEL_GUELTIGE_CHARGE_ANGEBEN' | translate}}
        </div>
      }
    </div>
  </div>
}
